import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import {
  DRAWER_KEY,
  FIREBASE_EVENTS,
  MILLISECONDS_MULTIPLIER,
  MODAL_KEYS,
  ONE_MINUTE,
} from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { finishProgress, setTimer, updateFirstTimerStatus } from 'slices/wifi'
import { fetchMessages } from 'slices/messages'
import { fetchInternet } from 'slices/contract'
import { setModal } from 'slices/modal'
import { BaseCard } from '../base-card'

export function WifiCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const [timeoutId, setTimeoutId] = useState(null)
  const messages = useSelector(state => state.messages)
  const {
    internet,
    selected: { id: idContract },
    countdownTimer,
    firstTimerFinished,
    inProgress,
  } = useSelector(({ contract, wifi, customer }) => ({
    ...contract,
    ...wifi,
    ...customer,
  }))

  useEffect(() => {
    dispatch(setTimer())
  }, [dispatch])

  useEffect(() => {
    function fullTimeout() {
      dispatch(fetchMessages(idContract))
      dispatch(setDrawer(''))
    }

    function oneMinuteTimeout() {
      dispatch(fetchInternet(idContract))
      dispatch(updateFirstTimerStatus(true))
    }

    function initializeTimers() {
      if (inProgress && countdownTimer) {
        const timeout = setTimeout(fullTimeout, [countdownTimer * MILLISECONDS_MULTIPLIER])
        setTimeoutId(timeout)

        if (countdownTimer > ONE_MINUTE) {
          const firstTimerCount = countdownTimer - ONE_MINUTE
          setTimeout(oneMinuteTimeout, [firstTimerCount * MILLISECONDS_MULTIPLIER])
        }
      }
    }

    initializeTimers()
  }, [dispatch, inProgress, idContract, countdownTimer])

  useEffect(() => {
    function validateTimerProgress() {
      if (firstTimerFinished && inProgress && !internet?.hasConfigurationInProgress) {
        dispatch(fetchMessages(idContract))
        dispatch(setDrawer(''))
      }
    }

    validateTimerProgress()
  }, [dispatch, inProgress, internet, firstTimerFinished, timeoutId, idContract])

  useEffect(() => {
    function handleMessagesUpdate() {
      const existsMandatoryUnreadMessage = messages.contentUnread.some(msg => msg.mandatory)

      if (firstTimerFinished && existsMandatoryUnreadMessage) {
        clearTimeout(timeoutId)
        dispatch(finishProgress())
        dispatch(setModal({ key: MODAL_KEYS.MESSAGES, locked: true }))
      }
    }

    handleMessagesUpdate()
  }, [dispatch, firstTimerFinished, messages, timeoutId])

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_WIFI_UPDATE)
    dispatch(setDrawer(DRAWER_KEY.MODEM))
  }

  return <BaseCard onClick={handleClick} text='Configurar Wi-fi' icon={<STATICS.WRENCH />} />
}
